import { cva } from "class-variance-authority";
import { type ReactNode } from "react";
import { cn } from "../../utils";

const tableCellContentVariants = cva(
  "px-4 text-sm text-neutral-500 flex items-center overflow-hidden text-ellipsis h-full",
  {
    variants: {
      align: {
        start: "justify-start",
        center: "justify-center text-center",
        end: "justify-end text-end",
      },
    },
    defaultVariants: {
      align: "start",
    },
  },
);

type Props = {
  children: ReactNode;
  align?: "start" | "center" | "end";
  className?: string;
};

export function TableCell({ children, align, className }: Props) {
  return (
    <div role="gridcell" className="min-w-0">
      <div className={cn(tableCellContentVariants({ align }), className)}>
        {children}
      </div>
    </div>
  );
}
